import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  constructor() { }

  breadcrumbJs: any;
  @Input('hide-last') hideLast: number = 0;

  private _items: any[];
  get items() { return this._items; }
  @Input('breadcrumb-data') set items(items: any[]) { this.setJs(items); }

  ngOnInit(): void { }

  private setJs(items: any[]) {
    if (!items?.length) return;
    this._items = items;
    this.breadcrumbJs = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.filter(_ => _.link?.length > 0 && _.title?.trim && !!_.title.trim())
        .map((_, i) => {
          return {
            '@type': 'ListItem',
            name: _.title,
            item: environment.app.url + _.link[0] +
              (_.link[1] ? Object.getOwnPropertyNames(_.link[1]).map(key => `;${key}=${encodeURIComponent(_.link[1][key])}`) : ''),
            position: i + 1
          };
        })
    };
  }
}
